import styled from 'styled-components'
import { BLACK, BLUE, CRIMSON_500, NEUTRAL_100 } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
`

export const Title = styled.span`
  color: ${BLACK};
  font-family: ${INTER.medium};
`

export const AmountContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const AmountText = styled.span<{ $isError?: boolean }>`
  color: ${({ $isError }) => $isError ? CRIMSON_500 : BLACK};
  font-family: ${INTER.bold};
  font-size: 24px;
`

export const MaxButton = styled.span`
  color: ${BLUE};
  font-family: ${INTER.semiBold};
  cursor: pointer;
  position: absolute;
  font-size: 14px;
  right: 16px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(0deg, #C9ECFF, #82ADFF, #7B69FF, #9B1BFF);
`

export const ErrorText = styled.span`
  color: ${CRIMSON_500};
  font-family: ${INTER.regular};
  font-size: 12px;
`

export const KeyboardFooterContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  width: 100%;
`
